import { useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { useHudOverlay } from "widgets/hud/model/overlayStore";
import { AddApiaryButtonWrapper, AnimatedWrap, Title } from "./styles";
import { useOutClick } from "app/lib/hooks/useOutClick";
import { useApiariesStore } from "entities/apiaries";
import { Apiaries } from "./Apiaries";
import { Button } from "@atomaro/ui-kit";
import { mergeRefs } from "shared/helpers";
import { ApiaryType } from "shared/types/common";
import { useState } from "react";
import { useHivesStore } from "entities/hives/model/store";
import { ApiaryWithHiveCount } from "../types";


export const ApiariesModal = () => {
  const openId = useHudOverlay((s) => s.openId);
  const close = useHudOverlay((s) => s.close);
  const setIsCreateApiaryOpen = useApiariesStore((s) => s.setIsModalOpen);
  

  const [activeWithCount, setActiveWithCount] = useState<ApiaryWithHiveCount[]>([]);
  const [archivedWithCount, setArchivedWithCount] = useState<ApiaryWithHiveCount[]>([]);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const nodeRef = useRef<HTMLDivElement | null>(null);

  useOutClick(containerRef, close);

  const apiaries = useApiariesStore((s) => s.apiaries);

  const isOpen = openId === "apiaries-modal";
  
  const activeApiaries = apiaries.filter((a: any) => !a.deletedAt);
  const archivedApiaries = apiaries.filter((a: any) => !!a.deletedAt);

    useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        // close();
      }
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [isOpen, close]);
useEffect(() => {
  if (!isOpen) return;

  const loadCounts = async () => {
    const getHives = useHivesStore.getState().getHives;

    const fetchCount = async (apiaryId: string | number) => {
      const hives = await getHives(apiaryId);
      return hives.length;
    };

    const enrich = async (apiaries: ApiaryType[]): Promise<ApiaryWithHiveCount[]> => {
      return Promise.all(
        apiaries.map(async (a) => ({
          ...a,
          hiveCount: await fetchCount(a.id),
        }))
      );
    };

    const apiaries = useApiariesStore.getState().apiaries;

    const active = apiaries.filter((a: any) => !a.deletedAt);
    const archived = apiaries.filter((a: any) => !!a.deletedAt);

    setActiveWithCount(await enrich(active));
    setArchivedWithCount(await enrich(archived));
  };

  loadCounts();
}, [isOpen]);

  return (
    <CSSTransition
      in={isOpen}
      timeout={{ enter: 200, exit: 150 }}
      classNames="hud-slide"
      unmountOnExit
      nodeRef={nodeRef}
    >
      <AnimatedWrap
        ref={mergeRefs(containerRef, nodeRef)}
        role="dialog"
        aria-modal="true"
        className="ApiariesModal"
        onClick={() => close()}
      >
        {activeApiaries.length > 0 && (
          <>
            <Title>Мои пасеки</Title>
            <Apiaries apiaries={activeWithCount} />
          </>
        )}

        {archivedApiaries.length > 0 && (
          <>
            <Title>Архивные пасеки</Title>
            <Apiaries apiaries={archivedWithCount} />
          </>
        )}

        <AddApiaryButtonWrapper>
          <Button
            label={"Новая пасека"}
            size={"m"}
            onClick={() => setIsCreateApiaryOpen(true)}
          />
        </AddApiaryButtonWrapper>
      </AnimatedWrap>
    </CSSTransition>
  );
};

export default ApiariesModal;
